import { Star } from 'lucide-react'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'

interface Testimonial {
  name: string
  context: string
  text: string
  result: string
  image: string
  initials: string
}

const testimonials: Testimonial[] = [
  {
    name: 'João',
    context: 'Ex-CLT',
    text: 'A estratégia de funil que o Lucas ensina mudou completamente meu jogo em 30 dias.',
    result: '+$15k/mês',
    image:
      'https://img.usecurling.com/p/256/256?q=young%20brazilian%20man%20portrait',
    initials: 'JO',
  },
  {
    name: 'Marina',
    context: 'Agência de 1 pessoa',
    text: 'Eu achava que precisava de equipe gigante, mas a automação da Elite me libertou.',
    result: '+$22k/mês',
    image:
      'https://img.usecurling.com/p/256/256?q=young%20brazilian%20woman%20smiling',
    initials: 'MA',
  },
  {
    name: 'Carlos',
    context: 'Empreendedor Digital',
    text: 'O melhor investimento que fiz este ano, o ROI foi praticamente imediato com o método.',
    result: '+$40k/mês',
    image:
      'https://img.usecurling.com/p/256/256?q=brazilian%20entrepreneur%20man',
    initials: 'CA',
  },
  {
    name: 'Ana',
    context: 'Gestora de Tráfego',
    text: 'Escalar no OFM parecia impossível até eu ter acesso aos scripts de vendas da mentoria.',
    result: '+$12k/semana',
    image:
      'https://img.usecurling.com/p/256/256?q=brazilian%20business%20woman',
    initials: 'AN',
  },
]

export const TestimonialsSection = () => {
  return (
    <section className="bg-[#F5F5F5] py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 sm:px-6">
        <h2 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-heading font-black text-center text-black mb-12 md:mb-20 leading-tight uppercase text-balance max-w-5xl mx-auto">
          Não é promessa. É resultado.
          <br className="hidden md:block" />
          <span className="text-primary mt-2 block text-xl sm:text-2xl md:text-5xl lg:text-6xl">
            Veja quem já está faturando.
          </span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto">
          {testimonials.map((item, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl md:rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 flex flex-col justify-between h-full border border-gray-100 group"
            >
              <div>
                <div className="flex items-center gap-4 mb-6">
                  <Avatar className="h-14 w-14 sm:h-16 sm:w-16 border-2 border-primary/20 shadow-sm group-hover:border-primary/50 transition-colors">
                    <AvatarImage
                      src={item.image}
                      alt={item.name}
                      className="object-cover"
                    />
                    <AvatarFallback className="bg-primary/10 text-primary font-bold text-lg">
                      {item.initials}
                    </AvatarFallback>
                  </Avatar>

                  <div className="flex flex-col">
                    <h3 className="font-heading font-bold text-xl sm:text-2xl text-black leading-none mb-1">
                      {item.name}
                    </h3>
                    <span className="font-sans text-xs sm:text-sm text-gray-500 font-medium uppercase tracking-wide mb-1.5">
                      {item.context}
                    </span>
                    <div className="flex gap-0.5">
                      {[1, 2, 3, 4, 5].map((_, i) => (
                        <Star
                          key={i}
                          className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#FFD700] fill-[#FFD700]"
                        />
                      ))}
                    </div>
                  </div>
                </div>

                <div className="mb-6 md:mb-8">
                  <p className="font-sans text-lg sm:text-xl text-gray-700 leading-relaxed italic relative pl-2 sm:pl-0">
                    <span className="absolute -top-4 -left-3 text-4xl sm:text-6xl text-gray-100 font-serif z-0 select-none hidden sm:block">
                      "
                    </span>
                    <span className="relative z-10">{item.text}</span>
                  </p>
                </div>
              </div>

              <div className="font-heading font-black text-2xl sm:text-3xl text-primary border-t border-gray-100 pt-4 md:pt-6">
                {item.result}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
